import { render } from "./AddPointVente.vue?vue&type=template&id=79cb7246&ts=true"
import script from "./AddPointVente.vue?vue&type=script&lang=ts"
export * from "./AddPointVente.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__